export default {
  API_URL: 'https://ntt-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://nttsandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
